<template>
  <div>
    <div class="sa-row sa-mt20 sa-d-f-a-center">
      <div class="sa-col-xs12 sa-col-sm5 sa-col-md5 sa-col-lg4">
        <div class="sa-form-group">
          <input
            type="text"
            class="sa-form-control sa-dark-search"
            placeholder="Search Diagonosis"
            v-model="icd_search"
            @input="changeType"
          /><i class="icon-search sa-search"></i>
        </div>
      </div>
    </div>
    <ul class="sa-infinite">
      <li v-for="(item, index) in list" :key="index">
                <input :value="item" v-model="primaryDiag" type="radio" :id="index" :name="index">
                <label :for="index">{{item.en}}</label>
      </li>
      <!-- <li>
        <input type="radio" :id="index" :name="index" />
        <label :for="index">assd</label>
      </li> -->

      <infinite-loading :identifier="infiniteId" @infinite="getIcdData" spinner="waveDots"></infinite-loading>
    </ul>
    <!-- <v-select
                :options="scientifics"
                :reduce="(c) => c.SNCODE"
                label="SCIENTIFIC_NAME"
                v-model="drugObj.sncode"
                id="scientific_name"
                name="Scientific_name"
                class="sa-v-slct-lg"
                ><span slot="no-options">No data</span></v-select
              >
              <span class="sa-val-err">{{ errors[0] }}</span> -->
    <div class="sa-ftr-btn">
      <button  @click="goback()" class="sa-btn-large sa-btn-primary sa-btn-block-xs">
        Continue
      </button>
    </div>
  </div>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import { pro_url, oh_url } from "../../../../../config/endpoints";
import axios from 'axios';
const api = '//hn.algolia.com/api/v1/search_by_date?tags=story';
export default {
props: ['scientificName'],
data() {
  return {
      page: 1,
      list: [],
      infiniteId: +new Date(),
      icd_search: "",
      primaryDiag: null
  }
},
methods: {
  goback(){
    if(this.primaryDiag){
      this.$parent.$parent.drugObj.icd10_code = this.primaryDiag
    }
    this.$parent.$parent.BupaDiagnoFlag = false
  },
  changeType() {
      this.page = 1;
      this.list = [];
      this.infiniteId += 1;
    },
   infiniteHandler($state) {
      axios.get(api, {
        params: {
          page: this.page,
        },
      }).then(({ data }) => {
        if (data.hits.length) {
          this.page += 1;
          this.list.push(...data.hits);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    getIcdData($state) {
      let _self = this
    _self.$store.dispatch('httpPost', {
        uri:`${oh_url}/general/ICD10codesListDesk`,
        body: {
          limit: 10,
	        page: this.page,
          en: this.icd_search
          }
      })
        .then((response) => {
          if ((response.status = 1000)) {
            if (response && response.status === 1000 && response.data && response.data.data && response.data.data.length ) {
               // _self.list =_.uniqBy(_self.list, function(o){ return o.icd10_code;});
                _self.page += 1
                _self.list.push(...response.data.data);
                _self.list =_.uniqBy(_self.list, function(o){ return o.icd10_code;});
                $state.loaded()
              } else {
                  $state.complete()
              }
            // _.map(response.data, (e) => {
            //   this.scientifics.push(e.scientifi_names)
            //   this.drugs.push(e.drug_names);
            //   return e;
            // });
          }
        })
        .catch((e) => {
          // console.log(e)
        });
    },
},
}
</script>
